import { getContext } from '@fiverr-private/fiverr_context';

const macPrefix = 'MAC';

/**
 * Checks if the current OS is mac based or not
 * The check is based on the current used agent.
 * @returns {Boolean}
 */
export const isMacOS = () => {
    try {
        const userAgent = getContext().userAgent || (navigator && navigator.userAgent);

        return userAgent && userAgent.toUpperCase().indexOf(macPrefix) >= 0;
    } catch {
        return false;
    }
};
